import {
  AdjustmentsHorizontalIcon,
  BookOpenIcon,
  BriefcaseIcon,
  BuildingOffice2Icon,
  CpuChipIcon,
  CurrencyDollarIcon,
  RectangleStackIcon,
  EllipsisHorizontalCircleIcon,
  MegaphoneIcon,
  StarIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline';
import type { SidebarIcon } from './sidebarMenuTypes';

export type SidebarDepartmentId =
  | 'relacionamento'
  | 'pessoas'
  | 'comercial'
  | 'produtos'
  | 'marketing'
  | 'financas'
  | 'operacoes'
  | 'sucesso-cliente'
  | 'tecnologia'
  | 'manual'
  | 'administracao';

export type SidebarDepartmentDefinition = {
  id: SidebarDepartmentId;
  label: string;
  icon: SidebarIcon;
  moduleCodes: readonly string[];
};

/**
 * Ordem e agrupamento do menu por departamento.
 * Códigos sem departamento caem em "Outros" no builder.
 */
export const SIDEBAR_DEPARTMENT_DEFINITIONS: readonly SidebarDepartmentDefinition[] = [
  {
    id: 'relacionamento',
    label: 'Relacionamento',
    icon: BuildingOffice2Icon,
    moduleCodes: [
      'dashboard.relationship',
      'core.companies',
      'core.contacts',
      'commercial.contracts',
      'commercial.projects',
    ],
  },
  {
    id: 'pessoas',
    label: 'Pessoas',
    icon: UserGroupIcon,
    moduleCodes: [
      'dashboard.people',
      'access-control.users',
      'access-control.teams',
      'access-control.roles',
      'access-control.permission-groups',
      'people.job-positions',
      'people.competencies',
      'people.evaluations',
      // people.my-team: Conta → após Meu perfil (Sidebar)
      // people.notes: injetado no builder para admin (RH) e gerente (gestor)
    ],
  },
  {
    id: 'comercial',
    label: 'Comercial',
    icon: BriefcaseIcon,
    moduleCodes: [
      'dashboard.commercial',
      'sales.opportunities',
      'sales.prospects',
      'sales.offer',
      'sales.pricing',
      'sales.market-segments',
      'sales.product-resources',
      'sales.buyer-personas',
      'sales.gtm-analytics',
    ],
  },
  {
    id: 'produtos',
    label: 'Portfólio',
    icon: RectangleStackIcon,
    moduleCodes: ['products.workspace', 'sales.products', 'sales.capabilities'],
  },
  {
    id: 'marketing',
    label: 'Marketing',
    icon: MegaphoneIcon,
    moduleCodes: ['dashboard.marketing', 'sales.campaign-tags'],
  },
  {
    id: 'financas',
    label: 'Finanças',
    icon: CurrencyDollarIcon,
    moduleCodes: [],
  },
  {
    id: 'operacoes',
    label: 'Operações',
    icon: WrenchScrewdriverIcon,
    moduleCodes: [
      'dashboard.operations',
      'operations.calendars',
      'strategic-planning',
    ],
  },
  {
    id: 'sucesso-cliente',
    label: 'Sucesso do Cliente',
    icon: StarIcon,
    moduleCodes: [
      'dashboard.customer-success',
      'customer-success.desk',
      'customer-success.tickets',
      'customer-success.service-catalog',
      'customer-success.analytics',
      'customer-success.channels',
      'customer-success.inbound',
      'customer-success.problems',
      'customer-success.engagement',
      'customer-success.health',
      'customer-success.settings',
    ],
  },
  {
    id: 'tecnologia',
    label: 'Tecnologia',
    icon: CpuChipIcon,
    moduleCodes: [
      'technology.overview',
      'technology.catalog',
      'technology.applications',
      'technology.portfolio',
      'technology.infrastructure',
      'technology.integrations',
      'technology.secrets',
      'technology.certificates',
      'technology.keys',
      'technology.ai-models',
      'technology.ai-prompts',
      'technology.ai-benchmarks',
      'technology.ai-costs',
      'technology.documentation',
      'technology.documentation-expired',
      'technology.documentation-views',
      'technology.deployments',
      'technology.backups',
      'technology.monitoring',
    ],
  },
  {
    id: 'administracao',
    label: 'Administração',
    icon: AdjustmentsHorizontalIcon,
    moduleCodes: [
      'access-control.modules',
      'storage',
      'settings.system',
      'settings.email-templates',
      'settings.email-queue',
      'settings.decision-engine',
      'monitor',
      'monitoring',
      'reports.access',
    ],
  },
  {
    id: 'manual',
    label: 'Manual',
    icon: BookOpenIcon,
    moduleCodes: [
      'manual',
      'manual.expired',
      'manual.views',
    ],
  },
];

export const SIDEBAR_OTHERS_DEPARTMENT_ICON: SidebarIcon = EllipsisHorizontalCircleIcon;
